import { config } from '@shakkerai/config';

export * from './image';
export * from './size';
export * from './helper';
export * from './elements';
export * from './getNextName';
export * from './reference';
export * from './generate';
export * from './inpaint';
export * from './crypto';
export * from './message';
export * from './model';
export * from './relationWord';
export * from './tool';
export * from './constant';
export * from './atom';
export * from './video';

export const isMainland = config.env === 'aliyun';
export const isOverseas = config.env === 'aws';
export const isTest = config.name === 'test';
